import { render, staticRenderFns } from "./Fragment.vue?vue&type=template&id=113b488e&scoped=true"
import script from "./Fragment.vue?vue&type=script&lang=js"
export * from "./Fragment.vue?vue&type=script&lang=js"
import style0 from "./Fragment.vue?vue&type=style&index=0&id=113b488e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b488e",
  null
  
)

export default component.exports